import React, { SVGProps } from 'react';

export const BranchIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="14"
      height="78"
      viewBox="0 0 14 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 1V69C1 73.4183 4.58172 77 9 77H13"
        stroke="#DDDFE5"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
